export default __webpack_public_path__ + "static/media/AdobeStock_446468716.8c7dcd2c.jpeg";